import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Mail, Award, Users, Heart, Target } from 'lucide-react';
import { Button } from '../components/ui/button';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CursorGlow from '../components/CursorGlow';
import ScrollProgress from '../components/ScrollProgress';

const Team = () => {
  const leadership = [
    {
      name: 'Ahmet Yılmaz',
      role: 'CEO & Kurucu',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face',
      bio: '15 yıllık teknoloji deneyimi. Önceden Fortune 500 şirketlerinde liderlik pozisyonlarında bulundu.',
      expertise: ['Strateji', 'İş Geliştirme', 'Liderlik'],
      social: { linkedin: '#', twitter: '#', email: 'ahmet@ruyan.com.tr' }
    },
    {
      name: 'Elif Demir',
      role: 'CTO',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop&crop=face',
      bio: 'Yazılım mimarisi ve yapay zeka uzmanı. MIT mezunu, 10+ yıl Silicon Valley deneyimi.',
      expertise: ['AI/ML', 'Yazılım Mimarisi', 'Cloud'],
      social: { linkedin: '#', twitter: '#', email: 'elif@ruyan.com.tr' }
    },
    {
      name: 'Mehmet Kaya',
      role: 'Creative Director',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&crop=face',
      bio: 'Uluslararası ödüllü tasarımcı. Kullanıcı deneyimi ve görsel tasarım tutkunu.',
      expertise: ['UI/UX', 'Branding', 'Design Systems'],
      social: { linkedin: '#', twitter: '#', email: 'mehmet@ruyan.com.tr' }
    },
    {
      name: 'Zeynep Arslan',
      role: 'Head of Development',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face',
      bio: 'Full-stack geliştirme lideri. 50+ başarılı proje deneyimi.',
      expertise: ['React', 'Node.js', 'DevOps'],
      social: { linkedin: '#', twitter: '#', email: 'zeynep@ruyan.com.tr' }
    }
  ];

  const team = [
    { name: 'Can Öztürk', role: 'Senior Developer', image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&h=300&fit=crop&crop=face' },
    { name: 'Ayşe Yıldız', role: 'UI/UX Designer', image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=300&h=300&fit=crop&crop=face' },
    { name: 'Burak Şahin', role: 'Mobile Developer', image: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=300&h=300&fit=crop&crop=face' },
    { name: 'Selin Aydın', role: 'Digital Marketing', image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=300&h=300&fit=crop&crop=face' },
    { name: 'Emre Koç', role: 'DevOps Engineer', image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=300&h=300&fit=crop&crop=face' },
    { name: 'Deniz Çelik', role: 'Product Manager', image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=300&h=300&fit=crop&crop=face' }
  ];

  const values = [
    { icon: Heart, title: 'Tutku', description: 'İşimizi seviyoruz ve bu her projede görünüyor' },
    { icon: Users, title: 'İşbirliği', description: 'Birlikte daha güçlüyüz' },
    { icon: Target, title: 'Sonuç Odaklı', description: 'Ölçülebilir başarı hedefliyoruz' },
    { icon: Award, title: 'Mükemmellik', description: 'Her detayda kalite standartları' }
  ];

  return (
    <div className="min-h-screen bg-slate-900">
      <CursorGlow />
      <ScrollProgress />
      <Header />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute w-[600px] h-[600px] bg-cyan-500/20 rounded-full blur-3xl top-0 right-1/4 animate-pulse"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Ekibimizle
            <span className="bg-gradient-to-r from-cyan-400 to-teal-400 bg-clip-text text-transparent"> Tanışın</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Tutkulu, yetenekli ve deneyimli profesyonellerden oluşan ekibimiz, 
            dijital dönüşüm yolculuğunuzda yanınızda.
          </p>
        </div>
      </section>

      {/* Leadership */}
      <section className="py-20 bg-slate-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center text-white mb-16">
            <span className="bg-gradient-to-r from-cyan-400 to-teal-400 bg-clip-text text-transparent">Liderlik Ekibi</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-8">
            {leadership.map((member, index) => (
              <div
                key={index}
                className="group bg-slate-800/40 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 hover:border-cyan-500/50 transition-all duration-500"
              >
                <div className="flex flex-col md:flex-row gap-6">
                  <div className="relative w-32 h-32 flex-shrink-0">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover rounded-xl group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>

                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-white mb-1">{member.name}</h3>
                    <p className="text-cyan-400 mb-3">{member.role}</p>
                    <p className="text-gray-400 text-sm mb-4">{member.bio}</p>

                    <div className="flex flex-wrap gap-2 mb-4">
                      {member.expertise.map((skill, idx) => (
                        <span
                          key={idx}
                          className="px-3 py-1 bg-cyan-500/10 border border-cyan-500/30 rounded-full text-cyan-400 text-xs"
                        >
                          {skill}
                        </span>
                      ))}
                    </div>

                    <div className="flex gap-3">
                      <a href={member.social.linkedin} className="text-gray-400 hover:text-cyan-400 transition-colors">
                        <Linkedin className="w-5 h-5" />
                      </a>
                      <a href={member.social.twitter} className="text-gray-400 hover:text-cyan-400 transition-colors">
                        <Twitter className="w-5 h-5" />
                      </a>
                      <a href={`mailto:${member.social.email}`} className="text-gray-400 hover:text-cyan-400 transition-colors">
                        <Mail className="w-5 h-5" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Members */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center text-white mb-16">
            <span className="bg-gradient-to-r from-cyan-400 to-teal-400 bg-clip-text text-transparent">Ekip Üyelerimiz</span>
          </h2>

          <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-8">
            {team.map((member, index) => (
              <div key={index} className="group text-center">
                <div className="relative mb-4 overflow-hidden rounded-2xl">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full aspect-square object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                </div>
                <h3 className="text-lg font-bold text-white mb-1">{member.name}</h3>
                <p className="text-cyan-400 text-sm">{member.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-slate-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center text-white mb-16">
            <span className="bg-gradient-to-r from-cyan-400 to-teal-400 bg-clip-text text-transparent">Değerlerimiz</span>
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-slate-800/40 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-6 text-center hover:border-cyan-500/50 transition-all"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <value.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{value.title}</h3>
                <p className="text-gray-400 text-sm">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ekibimize
            <span className="bg-gradient-to-r from-cyan-400 to-teal-400 bg-clip-text text-transparent"> Katılın</span>
          </h2>
          <p className="text-xl text-gray-400 mb-8">
            Yetenekli, tutkulu ve öğrenmeye açık profesyoneller arıyoruz.
          </p>
          <Link to="/kariyer">
            <Button className="bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white px-8 py-6 text-lg">
              Açık Pozisyonlar
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Team;
